import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { ReportService } from '../../../services/ReportService';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { GetIdleReportListPagingAndFilterResponse, GetIdleReportListPagingAndFilterResponseData, GetIdleReportListPagingAndFilterResponseItem, initialGetIdleReportListPagingAndFilterResponseData } from '../../../models/response/report/GetIdleReportListPagingAndFilterResponse';
import { GetIdleReportListPagingAndFilterRequest, initialGetIdleReportListPagingAndFilterRequest } from '../../../models/request/report/GetIdleReportListPagingAndFilterRequest';
import { ExportIdleReportListResponse } from '../../../models/response/report/ExportIdleReportListResponse ';
import IdleReportListFilters from './Components/IdleReportListFilters';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const IdleReportList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Raporlar > Sürücü Rölanti Raporu"
    const pageVersion = "2";
    const [data, setData] = useState<GetIdleReportListPagingAndFilterResponseData>(initialGetIdleReportListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetIdleReportListPagingAndFilterRequest>(initialGetIdleReportListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Tarih', name: 'dateStr', order: 0, isVisible: true },
            { title: 'Plaka', name: 'plate', order: 0, isVisible: true },
            { title: 'Sürücü', name: 'driverNameSurname', order: 0, isVisible: true },
            { title: 'Rölanti Başlangıç Tarihi', name: 'idleStartTimeStr', order: 0, isVisible: true },
            { title: 'Rölanti Bitiş Tarihi', name: 'idleEndTimeStr', order: 0, isVisible: true },
            { title: 'Süre (sn)', name: 'seconds', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Açıklama', name: 'desc', order: 0, isVisible: true },
            { title: 'Rölanti Başlangıç Konum', name: 'idleStartLocation', order: 0, isVisible: true },
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetIdleReportListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            if (_filter.selectedDevices.length == 0 || Helpers.isEmpty(_filter.startDate) || Helpers.isEmpty(_filter.endDate)) {
                toast.error('Lütfen boş alan bırakmayınız!')
                setData(initialGetIdleReportListPagingAndFilterResponseData);
                return;
            }

            dispatch(storeActivityIndicator(true))

            var response: GetIdleReportListPagingAndFilterResponse = await ReportService.getIdleReportListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportIdleReportListResponse = await ReportService.exportIdleReportList(buildExcelRequest(filter, mode, [], columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (ReportManager.ApplyIdleColumnFilters) aynı. Açıklama (okunur süre) filtresiz; Süre (sn) ile süzülür.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        dateStr: { type: 'date' },
        plate: { type: 'text' },
        driverNameSurname: { type: 'text' },
        idleStartTimeStr: { type: 'date' },
        idleEndTimeStr: { type: 'date' },
        seconds: { type: 'number' },
        idleStartLocation: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetIdleReportListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        var item2: any = item;
        return <td className={className}>{item2[column]}</td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <IdleReportListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    {/* Arama kutusu kaldırıldı (22.09.2026): raporda hiç çalışmıyordu; kolon
                        başlıklarının altındaki filtreler kullanılır. */}

                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th>{item.title}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={0}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default IdleReportList;